import React from "react";
import { BrowserRouter as Router, Route, Routes as RouterRoutes, useLocation } from "react-router";
import { dashboard as dashboardRoutes, auth as authRoutes } from "./index";

import DashboardLayout from "../layouts/Dashboard";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/auth/Page404";
import FeatureGuard from "../features/scheduler/FeatureGuard";

const RouteView = ({ Component }) => <Component location={useLocation()} />;

const childRoutes = (Layout, routes) =>
  routes.map(({ children, path, component: Component }, index) =>
    children ? (
      // Route item with children
      children.map(({ path, component: Component, feature }, index) => (
        <Route
          key={index}
          path={path}
          element={
            <Layout key={path}>
              {feature ? (
                <FeatureGuard feature={feature}>
                  <RouteView Component={Component} />
                </FeatureGuard>
              ) : (
                <RouteView Component={Component} />
              )}
            </Layout>
          }
        />
      ))
    ) : (
      // Route item without children
      <Route
        key={index}
        path={path}
        element={
          <Layout key={path}>
            <RouteView Component={Component} />
          </Layout>
        }
      />
    )
  );

const Routes = () => (
  <Router>
    <RouterRoutes>
      {childRoutes(DashboardLayout, dashboardRoutes)}
      {childRoutes(AuthLayout, authRoutes)}
      <Route
        path="*"
        element={
          <AuthLayout>
            <Page404 />
          </AuthLayout>
        }
      />
    </RouterRoutes>
  </Router>
);

export default Routes;
